import { useEffect } from "react";
import { useNavigate } from "react-router";

import { to } from "../to";
import { LOGIN_REDIRECT_EVENT } from "./auth-redirect";

const AuthRedirectListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectToLogin = () => {
      void navigate(to.login, { replace: true });
    };

    window.addEventListener(LOGIN_REDIRECT_EVENT, redirectToLogin);
    return () => window.removeEventListener(LOGIN_REDIRECT_EVENT, redirectToLogin);
  }, [navigate]);

  return null;
};

export { AuthRedirectListener };
